/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type UniversalCandidateHitSchemaRecency = typeof UniversalCandidateHitSchemaRecency[keyof typeof UniversalCandidateHitSchemaRecency] | null;


export const UniversalCandidateHitSchemaRecency = {
  added: 'added',
  viewed: 'viewed',
} as const;
